exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ag-row-selected .ag-cell {\r\n  background-color: #a6a8aa !important;\r\n  color: #000000;\r\n}", ""]);

